import request from '@/utils/request'

export function getAssessmentSubmissions(branchId, size, page, find, dates, dateType, status, dbForfeited, getMine, acceptDraft, companyStateFilter, mainIndustrySectorFilter, specialDate, sortDirection) {
  return request({
    url: `/msma/assessmentsubmissions/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      startDate: dates,
      dateType: dateType,
      status: status,
      getMine: getMine,
      dbForfeited: dbForfeited,
      acceptDraft: acceptDraft,
      companyStateFilter: companyStateFilter,
      mainIndustrySectorFilter: mainIndustrySectorFilter,
      specialDate: specialDate,
      sortDirection: sortDirection
    }
  })
}

export function reportingAssessmentSubmissions(branchId, size, page, find, dates, dateType, status, acceptDraft, companyStateFilter, mainIndustrySectorFilter, companyOSFARecognitionLabelFilter, specialDate, sortDirection) {
  return request({
    url: `/msma/assessmentsubmissions/reporting/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      startDate: dates,
      dateType: dateType,
      status: status,
      acceptDraft: acceptDraft,
      companyStateFilter: companyStateFilter,
      mainIndustrySectorFilter: mainIndustrySectorFilter,
      companyOSFARecognitionLabelFilter: companyOSFARecognitionLabelFilter,
      specialDate: specialDate,
      sortDirection: sortDirection
    }
  })
}

export function reportingExcelAssessmentSubmissions(branchId, dates, dateType, status, reportingType) {
  return request({
    url: `/msma/assessmentsubmissions/reportingExcel/${branchId}`,
    method: 'get',
    params: {
      startDate: dates,
      dateType: dateType,
      status: status,
      reportingType: reportingType
    },
    responseType: 'blob'
  })
}

export function reportingFieldAssessmentSubmissions(branchId, id, data) {
  return request({
    url: `/msma/assessmentsubmissions/reportingField/${branchId}/${id}`,
    method: 'post',
    data
  })
}

export function dmuDashboardMainAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/dmuDashboardMain/${branchId}`,
    method: 'get'
  })
}

export function dmuDashboardGraphCountAssessmentSubmissions(branchId, type) {
  return request({
    url: `/msma/assessmentsubmissions/dmuDashboardGraphCount/${branchId}`,
    method: 'get',
    params: {
      type: type
    }
  })
}

export function dmuDashboardOSFACountAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/dmuDashboardOSFACount/${branchId}`,
    method: 'get'
  })
}

export function selfAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/self/${branchId}`,
    method: 'get'
  })
}

export function saveAssessmentSubmissions(branchId, data) {
  return request({
    url: `/msma/assessmentsubmissions/save/${branchId}`,
    method: 'post',
    data
  })
}

export function assessorsaveAssessmentSubmissions(branchId, assessmentsubmissionId, data) {
  return request({
    url: `/msma/assessmentsubmissions/assessorsave/${branchId}/${assessmentsubmissionId}`,
    method: 'post',
    data
  })
}

export function dmusaveAssessmentSubmissions(branchId, assessmentsubmissionId, data) {
  return request({
    url: `/msma/assessmentsubmissions/dmusave/${branchId}/${assessmentsubmissionId}`,
    method: 'post',
    data
  })
}

export function postsaveAssessmentSubmissions(branchId, data) {
  return request({
    url: `/msma/assessmentsubmissions/postsave/${branchId}`,
    method: 'post',
    data
  })
}

export function payAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/pay/${branchId}`,
    method: 'post'
  })
}

export function fpxPayAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/fpxPay/${branchId}`,
    method: 'post'
  })
}

export function acceptOSFAAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/acceptOSFA/${branchId}`,
    method: 'post'
  })
}

export function fichooseAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/fiChoose/${branchId}`,
    method: 'post'
  })
}

export function submitAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/submit/${branchId}`,
    method: 'post'
  })
}

export function assessorsubmitAssessmentSubmissions(branchId, assessmentsubmissionId) {
  return request({
    url: `/msma/assessmentsubmissions/assessorsubmit/${branchId}/${assessmentsubmissionId}`,
    method: 'post'
  })
}

export function devSubmitAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/devSubmit/${branchId}`,
    method: 'post'
  })
}

export function assessordevSubmitAssessmentSubmissions(branchId, assessmentsubmissionId) {
  return request({
    url: `/msma/assessmentsubmissions/assessordevSubmit/${branchId}/${assessmentsubmissionId}`,
    method: 'post'
  })
}

export function getAssessmentSubmissionById(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findAssessmentSubmissions(branchId, find) {
  return request({
    url: `/msma/assessmentsubmissions/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function createAssessmentSubmissions(branchId, data) {
  return request({
    url: `/msma/assessmentsubmissions/create/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicateAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updateAssessmentSubmissions(branchId, id, data) {
  return request({
    url: `/msma/assessmentsubmissions/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function assignAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/assign/${branchId}/${id}`,
    method: 'post'
  })
}

export function assessorreleasereportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/assessorreleasereport/${branchId}/${id}`,
    method: 'post'
  })
}

export function dmureleasereportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/dmureleasereport/${branchId}/${id}`,
    method: 'post'
  })
}

export function dmuunreleasereportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/dmuunreleasereport/${branchId}/${id}`,
    method: 'post'
  })
}

export function dmupassbackreportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/dmupassbackreport/${branchId}/${id}`,
    method: 'post'
  })
}

export function dmupasstoassessorreportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/dmupasstoassessorreport/${branchId}/${id}`,
    method: 'post'
  })
}

export function assessoracceptAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/assessoraccept/${branchId}/${id}`,
    method: 'post'
  })
}

export function assessorrejectAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/assessorreject/${branchId}/${id}`,
    method: 'post'
  })
}

export function proofAcceptAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/proofAccept/${branchId}/${id}`,
    method: 'post'
  })
}

export function proofRejectAssessmentSubmissions(branchId, id, data) {
  return request({
    url: `/msma/assessmentsubmissions/proofReject/${branchId}/${id}`,
    method: 'post',
    data
  })
}

export function dmuScreenAssessmentSubmissions(branchId, id, data) {
  return request({
    url: `/msma/assessmentsubmissions/dmuScreen/${branchId}/${id}`,
    method: 'post',
    data
  })
}

export function ganttChartAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/ganttChart/${branchId}/${id}`,
    method: 'post'
  })
}

export function assessorReportAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/assessorReport/${branchId}/${id}`,
    method: 'post',
    responseType: 'blob'
  })
}

export function companyAnswerAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/companyAnswer/${branchId}/${id}`,
    method: 'post',
    responseType: 'blob'
  })
}

export function removeAssessmentSubmissions(branchId, id) {
  return request({
    url: `/msma/assessmentsubmissions/id/${branchId}/${id}`,
    method: 'delete'
  })
}

export function resetFlagsAssessmentSubmissions(branchId) {
  return request({
    url: `/msma/assessmentsubmissions/resetFlags/${branchId}`,
    method: 'post'
  })
}

export function saveAssessorRemarksTurboReportAssessmentSubmissions(branchId, data) {
  return request({
    url: `/msma/assessmentsubmissions/saveAssessorRemarksTurboReport/${branchId}`,
    method: 'post',
    data
  })
}

export function downloadOsfaDeclaration(data) {
  return request({
    url: `/puppeteer/msma/osfaDeclaration`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/msmaAssessmentSubmissions.js